exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border[data-v-e3858246] {\n  border: 1px solid #c9c9c9;\n  margin-bottom: 5px;\n  padding: 5px 5px 5px 5px;\n}\n.title[data-v-e3858246] {\n  height: 25px;\n}\n.title .text[data-v-e3858246] {\n  font-weight: bold;\n  float: left;\n  line-height: 25px;\n}\n.title .action[data-v-e3858246] {\n  float: right;\n}\n", ""]);

// exports
